import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import './permission'
import Initializer from './plugins'
import './style/base.less'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
  created:Initializer,
}).$mount('#app')
